import { GetServerSidePropsContext, NextPageContext } from 'next'
import Cookie from 'cookie-universal'
import { ONE_DAY } from '@mc/constants'

const GOOGLE_ONE_TAP_PAGE_LOAD_COOKIE = 'google_one_tap_page_load'

// To show modal after 2nd page load
export const getGoogleOneTapPageLoadCookieSSR = async (
  ctx: GetServerSidePropsContext | NextPageContext,
) => {
  const cookies = Cookie(ctx.req, ctx.res)
  const cookie = cookies.get(GOOGLE_ONE_TAP_PAGE_LOAD_COOKIE)
  return cookie
}

export const setGoogleOneTapPageLoadCookie = async () => {
  const cookies = Cookie()
  cookies.set(GOOGLE_ONE_TAP_PAGE_LOAD_COOKIE, true, {
    maxAge: ONE_DAY,
    path: '/',
  })
}
